module.exports = __webpack_public_path__ + "img/wx.5eedd3de.jpg";